<script lang="ts">
  export const name = 'Upload';
  export let className = '';
</script>

<svg viewBox="0 0 24 24" class={className} xmlns="http://www.w3.org/2000/svg">
  <path d="M11 15H13V9H16L12 4L8 9H11V15Z" />
  <path d="M19 17H5V11H2V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V11H19V17Z" />
  <rect x="10" y="9" width="4" height="6" />
</svg>
